import { render, staticRenderFns } from "./Sernapesca.vue?vue&type=template&id=e6ffa99a&"
import script from "./Sernapesca.vue?vue&type=script&lang=js&"
export * from "./Sernapesca.vue?vue&type=script&lang=js&"
import style0 from "./Sernapesca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports